import { defineComponent } from 'vue'
import type { PropType, ExtractPropTypes } from 'vue'

export const querytableColumnMultiselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],

  code: [String, Array] as PropType<string | { value: string; content: string }[]>,
})

export type QuerytableColumnMultiselectProps = Partial<ExtractPropTypes<ReturnType<typeof querytableColumnMultiselectProps>>>

export default defineComponent({
  name: 'OQuerytableColumnMultiselect',
  inheritAttrs: false,
  props: querytableColumnMultiselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
